export const MULTI_INPUT_PLACEHOLDER_TEXTS = {
  CHOOSE: 'Must choose from list',
  EMPTY: 'Cannot be set',
  FEATURE: 'Type new feature',
  CAMPAIGN: 'Type new campaign',
  CHANNEL: 'Type new channel',
  TAGS: 'Type new tags',
  LINK_DATA: 'Type new link data',
  WEB_URL: 'Type new web url',
  SELECT: 'Select...',
  TITLE: 'Enter a title',
  DESCRIPTION: 'Enter a description',
  IMAGE_URL: 'Enter an image URL',
  ORIGINAL_WEB_URL: 'https://www.example.com',
};
